import React, {SFC, useState} from "react";
import {Link, Redirect} from "react-router-dom";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import {Typography, makeStyles} from "@material-ui/core";

import {UserSignUpForm, VetSignUpForm} from "../../../Components/Forms/SignUp";
import UserTypeRadio from "../../../Components/Basics/UserTypeRadio";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {ReactComponent as LogoSVG} from "../../../Images/logo.svg";
import {useBranding} from "../../../hooks/useBranding";
import ConfirmEmail from "../../../Components/ConfirmEmail/ConfirmEmail";
import API from "../../../helpers/apiHelpers";

const useStyles = makeStyles({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        position: "relative",
        marginBottom: 55,
        zIndex: 1,
    },
});

interface Props {
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
}

const UserSignUp: SFC<Props> = ({setIsOnBoarding}: Props) => {
    const [userType, setUserType] = useState<"user" | "vet">("user");
    const [isEmailConfirmed, setIsEmailConfirmed] = useState(undefined);
    const classes = useStyles();
    const branding = useSelector((state: RootState) => state?.branding);
    const isWhiteLabel = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    useBranding();

    return (
        <>
            {
                (API.isLoggedIn && isEmailConfirmed) ? <Redirect to="/"/> :
                    <Container className={classes.containerRoot} maxWidth="sm">
                        <Card className={classes.cardRoot} style={{paddingBottom: isWhiteLabel ? "0" : "40px"}}>
                            {isEmailConfirmed === false
                                ?
                                <ConfirmEmail/>
                                :
                                <>
                                    <Box display="flex" justifyContent="center">
                                        {
                                            isWhiteLabel
                                            &&
                                            <img
                                                src={branding.logo}
                                                width="60%"
                                            />
                                        }
                                    </Box>

                                    <Box marginTop="40px" marginBottom="8px">
                                        <Typography
                                            variant="h2"
                                            align="center"
                                        >
                                            Get started
                                        </Typography>
                                    </Box>
                                    <Box marginBottom="24px">
                                        <Typography
                                            align="center"
                                        >
                                            Start scheduling virtual appointments.
                                        </Typography>
                                    </Box>
                                    {
                                        !isWhiteLabel &&
                                        <UserTypeRadio
                                            userType={userType}
                                            setUserType={setUserType}
                                        />
                                    }
                                    {
                                        userType === "user" ?
                                            <UserSignUpForm setIsOnBoarding={setIsOnBoarding}
                                                setIsEmailConfirmed={setIsEmailConfirmed}/>
                                            :
                                            <VetSignUpForm setIsOnBoarding={setIsOnBoarding}
                                                setIsEmailConfirmed={setIsEmailConfirmed}/>
                                    }
                                    {
                                        isWhiteLabel &&
                                        <Box display="flex" justifyContent="center" alignItems="center" marginTop="15px">
                                            <Typography color="primary" style={{fontSize: 14, marginRight: "10px"}}>Powered
                                                by</Typography>
                                            < LogoSVG style={{width: 47}}/>
                                        </Box>
                                    }
                                </>}
                        </Card>


                        <Typography style={{fontSize: "20px"}} align="center">
                            Have an account?&nbsp;<Link to="/login/?login=true">Login!</Link>
                        </Typography>
                    </Container>
            }
        </>);
};

export default UserSignUp;
